import httpClient from './httpClient'
import { getDateRangeInTimeZone } from '@/utils/dateTimeUtils'
import { buildCallLogsFilter, SELLER_CALL_LOGS_FILTER_FIELDS } from '@/utils/callLogsFilter'

const END_POINT = '/reporting/seller'

// Spread into a request body: adds `filter` only when something restricts the calls
function filterBody(filter) {
  const built = buildCallLogsFilter(filter, SELLER_CALL_LOGS_FILTER_FIELDS)

  return built ? { filter: built } : {}
}

const SellerCallLogsAPI = {
  // sortDescending: by call date; the API puts the newest first when it is left out
  async getSellerCallLogs(accountId, { from, to, timeZone, pageSize, pageNumber, sortDescending, filter }) {
    const url = `${END_POINT}/${accountId}/calls`

    const { fromTime, toTime } = getDateRangeInTimeZone([from, to], timeZone)

    return httpClient.post(url, {
      dateFrom: fromTime,
      dateTo: toTime,
      timeZone,
      pageSize,
      pageNumber,
      sortDescending,
      ...filterBody(filter)
    })
  },

  async getSellerTotalCalls(accountId, { from, to, timeZone, filter }) {
    const url = `${END_POINT}/${accountId}/total`

    const { fromTime, toTime } = getDateRangeInTimeZone([from, to], timeZone)

    return httpClient.post(url, {
      dateFrom: fromTime,
      dateTo: toTime,
      ...filterBody(filter)
    })
  },

  async exportSellerCalls(accountId, { from, to, timeZone, filter }) {
    const url = `${END_POINT}/${accountId}/export`

    const { fromTime, toTime } = getDateRangeInTimeZone([from, to], timeZone)

    return httpClient.post(url, {
      dateFrom: fromTime,
      dateTo: toTime,
      timeZone,
      ...filterBody(filter)
    })
  },

  // The traffic sources and offers of the account's calls inside the window
  async getCallFilterOptions(accountId, { from, to, timeZone }) {
    const url = `${END_POINT}/${accountId}/calls/filter-options`

    const { fromTime, toTime } = getDateRangeInTimeZone([from, to], timeZone)

    return httpClient.post(url, {
      dateFrom: fromTime,
      dateTo: toTime,
      timeZone
    })
  },

  async getSellerDisputedCalls(accountId, { from, to, timeZone, pageSize, pageNumber }) {
    const url = `${END_POINT}/${accountId}/disputed-calls`

    const { fromTime, toTime } = getDateRangeInTimeZone([from, to], timeZone)

    return httpClient.post(url, {
      dateFrom: fromTime,
      dateTo: toTime,
      timeZone,
      pageSize,
      pageNumber
    })
  },
}

export default SellerCallLogsAPI